import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import NotFound from "@/pages/NotFound";
import globals from "@/globals";
import Layout2 from "@/layout/Layout2";
import authGuard from "@/auth/authGuard";

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  base: "/",
  mode: "history",
  routes: [
    {
      path: "/",
      component: Layout2,
      children: [
        {
          path: "",
          component: () => import("@/pages/Overview/Overview")
        },
        {
          path: "trends",
          component: () => import("@/pages/Trends/Trends")
        },
        {
          path: "sales",
          component: () => import("@/pages/Sales/Sales")
        },
        {
          path: "machines",
          component: () => import("@/pages/Machines/Machines")
        },
        {
          path: "machines/archived",
          component: () => import("@/pages/Machines/Archived")
        },
        {
          path: "machines/add",
          component: () => import("@/pages/Machines/Add")
        },
        {
          name: "machine",
          path: "machines/:id",
          props: true,
          component: () => import("@/pages/Machines/Machine"),
          children: [
            {
              name: "machineDetails",
              path: "",
              component: () => import("@/pages/Machines/MachineDetails"),
              props: true
            },
            {
              name: "machineInteractions",
              path: "interactions",
              component: () => import("@/pages/Machines/Interactions"),
              props: true
            },
            {
              name: "machineService",
              path: "service",
              component: () => import("@/pages/Machines/Service"),
              props: true
            },
            {
              name: "machineInventory",
              path: "inventory",
              component: () => import("@/pages/Machines/Inventory"),
              props: true
            }
          ]
        },
        {
          path: "groups",
          component: () => import("@/pages/Groups/Groups")
        },
        {
          path: "groups/add",
          component: () => import("@/pages/Groups/Add")
        },
        {
          name: "editGroup",
          path: "groups/:id/edit",
          component: () => import("@/pages/Groups/Edit"),
          props: true
        },
        {
          path: "products",
          component: () => import("@/pages/Products/Products")
        },
        {
          path: "products/add",
          component: () => import("@/pages/Products/Add")
        },
        {
          name: "editProduct",
          path: "products/:id/edit",
          component: () => import("@/pages/Products/Edit"),
          props: true
        },
        {
          path: "planograms",
          component: () => import("@/pages/Planograms/Planograms")
        },
        {
          path: "planograms/add",
          component: () => import("@/pages/Planograms/Add")
        },
        {
          name: "editPlanogram",
          path: "planograms/:id/edit",
          component: () => import("@/pages/Planograms/Edit"),
          props: true
        },
        {
          path: "priceLists",
          component: () => import("@/pages/PriceLists/PriceLists")
        },
        {
          path: "priceLists/add",
          component: () => import("@/pages/PriceLists/Add")
        },
        {
          name: "editPriceList",
          path: "priceLists/:id/edit",
          component: () => import("@/pages/PriceLists/Edit"),
          props: true
        },
        {
          path: "attracts",
          component: () => import("@/pages/Attracts/Attracts")
        },
        {
          path: "attracts/add",
          component: () => import("@/pages/Attracts/Add")
        },
        {
          name: "editAttract",
          path: "attracts/:id/edit",
          component: () => import("@/pages/Attracts/Edit"),
          props: true
        },
        {
          path: "service",
          component: () => import("@/pages/Service/Service")
        },
        {
          path: "users",
          component: () => import("@/pages/Users/Users")
        },
        {
          name: "addUser",
          path: "users/add",
          component: () => import("@/pages/Users/Add")
        },
        {
          name: "user",
          path: "users/:id",
          props: true,
          component: () => import("@/pages/Users/User"),
          children: [
            {
              name: "userInfo",
              path: "",
              component: () => import("@/pages/Users/UserInfo"),
              props: true
            },
            {
              name: "permissions",
              path: "permissions",
              component: () => import("@/pages/Users/Permissions"),
              props: true
            },
            {
              name: "password",
              path: "password",
              component: () => import("@/pages/Users/Password"),
              props: true
            }
          ]
        }
      ]
    },
    {
      // 404 Not Found page
      path: "*",
      component: NotFound
    }
  ]
});

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector(".app-splash-screen");
  if (splashScreen) {
    splashScreen.style.opacity = 0;
    setTimeout(
      () =>
        splashScreen &&
        splashScreen.parentNode &&
        splashScreen.parentNode.removeChild(splashScreen),
      300
    );
  }
  // On small screens collapse sidenav
  if (
    window.layoutHelpers &&
    window.layoutHelpers.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0);
});

router.beforeEach((to, from, next) => {
  document.body.classList.add("app-loading");
  setTimeout(() => {
    authGuard(to, from, next);
  }, 10);
});

export default router;
